var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-container table_top_btn" },
    [
      _vm.customConfig || _vm.navButtons.length > 0
        ? _c(
            "vab-box-area",
            [
              _c(
                "vab-box-area-left-panel",
                _vm._b({}, "vab-box-area-left-panel", _vm.$attrs, false),
                [
                  _vm.navButtons.length > 0
                    ? _vm._l(_vm.navButtons, function (btn, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            btn.type == "primary"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.$baseLodash.isFunction(
                                              btn.show
                                            )
                                              ? btn.show()
                                              : true,
                                            expression:
                                              "$baseLodash.isFunction(btn.show) ? btn.show() : true",
                                          },
                                          {
                                            name: "permissions",
                                            rawName: "v-permissions",
                                            value: btn.permissions,
                                            expression: "btn.permissions",
                                          },
                                        ],
                                        staticClass: "chagne_btn",
                                        attrs: {
                                          icon: btn.icon,
                                          type: btn.type,
                                          plain: btn.plain,
                                          disabled: btn.disabled,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleClick(null, btn)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "felx_start flex_center_align",
                                          },
                                          [
                                            btn.svg
                                              ? _c("svg-icon", {
                                                  staticClass: "className",
                                                  attrs: {
                                                    "icon-class": btn.svg,
                                                  },
                                                })
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "btnname",
                                                class: btn.svg ? "" : "btnPl0",
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(btn.name) + " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            btn.type == "hollow" && !btn.hidden
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "permissions",
                                          rawName: "v-permissions",
                                          value: btn.permissions,
                                          expression: "btn.permissions",
                                        },
                                      ],
                                      staticClass:
                                        "flex_start flex_center_align hollow_box",
                                      class: { no_select: btn.noSelect },
                                      style: {
                                        "--font-color": btn.fontColor,
                                        "--border-color": btn.borderColor,
                                        "--hover-color": btn.hoverColor,
                                        background: btn.defaultColor,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleClick(null, btn)
                                        },
                                      },
                                    },
                                    [
                                      btn.svg
                                        ? _c("svg-icon", {
                                            staticClass: "className",
                                            attrs: { "icon-class": btn.svg },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "btnname",
                                          class: btn.svg ? "" : "pl0",
                                        },
                                        [_vm._v(" " + _vm._s(btn.name) + " ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            btn.type == "slot" && !btn.hidden
                              ? _c("customeSlot", {
                                  directives: [
                                    {
                                      name: "permissions",
                                      rawName: "v-permissions",
                                      value: btn.permissions,
                                      expression: "btn.permissions",
                                    },
                                  ],
                                  attrs: { render: btn.render, params: btn },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      })
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "vab-box-area-right-panel",
                { attrs: { span: _vm.rightSpan } },
                [
                  _c(
                    "div",
                    { staticClass: "flex_start" },
                    [
                      _vm.rightButtons.length > 0
                        ? _vm._l(_vm.rightButtons, function (btn, index) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                btn.type == "primary"
                                  ? [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.$baseLodash.isFunction(
                                                btn.show
                                              )
                                                ? btn.show()
                                                : true,
                                              expression:
                                                "$baseLodash.isFunction(btn.show) ? btn.show() : true",
                                            },
                                          ],
                                          staticClass: "chagne_btn",
                                          attrs: {
                                            icon: btn.icon,
                                            type: btn.type,
                                            disabled: btn.disabled,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleClick(null, btn)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex_start flex_center_align",
                                            },
                                            [
                                              btn.svg
                                                ? _c("svg-icon", {
                                                    staticClass: "className",
                                                    attrs: {
                                                      "icon-class": btn.svg,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _c(
                                                "span",
                                                { staticClass: "btnname" },
                                                [_vm._v(_vm._s(btn.name))]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                btn.type == "hollow" && !btn.hidden
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex_start flex_center_align hollow_box",
                                          style: {
                                            "--font-color": btn.fontColor,
                                            "--border-color": btn.borderColor,
                                            "--hover-color": btn.hoverColor,
                                            background: btn.defaultColor,
                                          },
                                        },
                                        [
                                          btn.svg
                                            ? _c("svg-icon", {
                                                staticClass: "className",
                                                attrs: {
                                                  "icon-class": btn.svg,
                                                },
                                              })
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            { staticClass: "btnname" },
                                            [_vm._v(_vm._s(btn.name))]
                                          ),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                                btn.type == "slot" && !btn.hidden
                                  ? _c("customeSlot", {
                                      attrs: {
                                        render: btn.render,
                                        params: btn,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              2
                            )
                          })
                        : _vm._e(),
                      _vm.customConfig
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "set_item flex_start flex_center_align",
                              on: { click: _vm.showProduntItem },
                            },
                            [
                              _c("svg-icon", {
                                staticClass: "iconName",
                                attrs: { "icon-class": "item" },
                              }),
                              _c("span", { staticClass: "item_word" }, [
                                _vm._v("表示項目設定"),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "vab_table_body" },
        [
          _vm.hasPager
            ? _c("el-pagination", {
                ref: "page",
                attrs: {
                  "current-page": _vm.requestParams.page,
                  layout: _vm.layout,
                  "page-size": _vm.requestParams.rows,
                  total: _vm.total,
                },
                on: {
                  "current-change": _vm.handleCurrentChange,
                  "size-change": _vm.handleSizeChange,
                },
              })
            : _vm._e(),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "table",
              staticClass: "changeTable",
              attrs: {
                border: "",
                data: _vm.dataSource,
                "element-loading-text": _vm.elementLoadingText,
                "max-height": _vm.maxHeight,
                size: "mini",
                stripe: true,
                "show-summary": _vm.showSummary,
                "summary-method": _vm.getSummaries,
                "show-header": _vm.showHeader,
                "row-class-name": _vm.rowClassName,
                "span-method": _vm.spanMethod,
                "cell-style": _vm.cellStyle,
                "tree-props": _vm.treeProps,
                "row-key": _vm.rowKey,
                "empty-text": _vm.$t(
                  "validateMessage." + _vm.$messageCode.E00000104.name
                ),
                "default-expand-all": _vm.$attrs["default-expand-all"],
                "highlight-current-row": !_vm.multiSelect,
                "header-cell-class-name": _vm.cellClass,
              },
              on: {
                "filter-change": _vm.filterHandler,
                "row-click": _vm.handleRowClick,
                "selection-change": _vm.selectionChange,
                "current-change": _vm.setSelectRows,
                "sort-change": _vm.handleSort,
                "header-contextmenu": _vm.rightClick,
                select: _vm.getSelectRows,
                "select-all": _vm.handleSelectAll,
              },
            },
            [
              _vm.multiSelect
                ? _c("el-table-column", {
                    staticStyle: { "margin-left": "5px" },
                    attrs: {
                      type: "selection",
                      "class-name": "selection_change",
                      width: "45px",
                      selectable: _vm.selectable,
                      "reserve-selection": _vm.rowKey ? true : false,
                    },
                  })
                : _vm._e(),
              _vm._l(_vm.finallyColumns, function (column, index) {
                return [
                  column.slotScope
                    ? [
                        !column.sortable
                          ? _c(
                              "el-table-column",
                              _vm._b(
                                {
                                  key: index + "render",
                                  attrs: { index: index },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("ex-slot", {
                                              attrs: {
                                                column: column,
                                                index: scope.$index,
                                                render: column.render,
                                                row: scope.row,
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                "el-table-column",
                                Object.assign(
                                  {},
                                  _vm.defaultColumnConfig,
                                  column
                                ),
                                false
                              )
                            )
                          : _vm.hasPager || _vm.enSortable
                          ? _c(
                              "el-table-column",
                              _vm._b(
                                {
                                  key: index + "render",
                                  attrs: { index: index, sortable: "custom" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("ex-slot", {
                                              attrs: {
                                                column: column,
                                                index: scope.$index,
                                                render: column.render,
                                                row: scope.row,
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                "el-table-column",
                                Object.assign(
                                  {},
                                  _vm.defaultColumnConfig,
                                  column
                                ),
                                false
                              )
                            )
                          : _c(
                              "el-table-column",
                              _vm._b(
                                {
                                  key: index + "render",
                                  attrs: { index: index, sortable: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("ex-slot", {
                                              attrs: {
                                                column: column,
                                                index: scope.$index,
                                                render: column.render,
                                                row: scope.row,
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                "el-table-column",
                                Object.assign(
                                  {},
                                  _vm.defaultColumnConfig,
                                  column
                                ),
                                false
                              )
                            ),
                      ]
                    : [
                        column.type === "actions"
                          ? _c(
                              "el-table-column",
                              _vm._b(
                                {
                                  key: index + "actions",
                                  attrs: { index: index },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            column.info &&
                                            _vm.$baseLodash.isFunction(
                                              column.info
                                            )
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: column.show
                                                          ? column.show(
                                                              scope.row
                                                            )
                                                          : true,
                                                        expression:
                                                          "column.show ? column.show(scope.row) : true",
                                                      },
                                                      {
                                                        name: "permissions",
                                                        rawName:
                                                          "v-permissions",
                                                        value: (function () {
                                                          return _vm.handlePermission(
                                                            column.permissions,
                                                            scope.row
                                                          )
                                                        })(),
                                                        expression:
                                                          "\n                  (() => handlePermission(column.permissions, scope.row))()\n                ",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "changebtn mini",
                                                    attrs: {
                                                      disabled: column.disabled
                                                        ? column.disabled(
                                                            scope.row
                                                          )
                                                        : false,
                                                      type: "primary",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return column.click(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          column.info(scope.row)
                                                        ) +
                                                        " "
                                                    ),
                                                    column.svg
                                                      ? _c("svg-icon", {
                                                          staticClass:
                                                            "iconName",
                                                          attrs: {
                                                            "icon-class":
                                                              column.svg,
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : column.info &&
                                                _vm.$baseLodash.isString(
                                                  column.info
                                                )
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: column.show
                                                          ? column.show(
                                                              scope.row
                                                            )
                                                          : true,
                                                        expression:
                                                          "column.show ? column.show(scope.row) : true",
                                                      },
                                                      {
                                                        name: "permissions",
                                                        rawName:
                                                          "v-permissions",
                                                        value: (function () {
                                                          return _vm.handlePermission(
                                                            column.permissions,
                                                            scope.row
                                                          )
                                                        })(),
                                                        expression:
                                                          "\n                  (() => handlePermission(column.permissions, scope.row))()\n                ",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "changebtn mini",
                                                    class:
                                                      column.info.length == 2
                                                        ? "changebtn_62"
                                                        : "",
                                                    attrs: {
                                                      disabled: column.disabled
                                                        ? column.disabled(
                                                            scope.row
                                                          )
                                                        : false,
                                                      type: "primary",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return column.click(
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          column.info || "詳細"
                                                        ) +
                                                        " "
                                                    ),
                                                    column.svg
                                                      ? _c("svg-icon", {
                                                          staticClass:
                                                            "iconName",
                                                          attrs: {
                                                            "icon-class":
                                                              column.svg,
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "el-dropdown",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "disabled",
                                                        rawName: "v-disabled",
                                                      },
                                                    ],
                                                    attrs: {
                                                      "hide-on-click": true,
                                                      trigger: "click",
                                                    },
                                                    on: {
                                                      command:
                                                        _vm.handleCommand,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticClass:
                                                          "changebtn mini changebtn_center changebtn_62",
                                                        attrs: {
                                                          type: "primary",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(" 操作 "),
                                                        _c("svg-icon", {
                                                          staticClass:
                                                            "table_action",
                                                          attrs: {
                                                            "icon-class":
                                                              "down_line2",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-dropdown-menu",
                                                      {
                                                        attrs: {
                                                          slot: "dropdown",
                                                        },
                                                        slot: "dropdown",
                                                      },
                                                      _vm._l(
                                                        column.actions,
                                                        function (action, j) {
                                                          return _c(
                                                            "div",
                                                            { key: j + "btn" },
                                                            [
                                                              _vm.$baseLodash.has(
                                                                action,
                                                                "show"
                                                              ) &&
                                                              _vm.$baseLodash.isBoolean(
                                                                action.show
                                                              )
                                                                ? [
                                                                    action.show
                                                                      ? _c(
                                                                          "el-dropdown-item",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "permissions",
                                                                                  rawName:
                                                                                    "v-permissions",
                                                                                  value:
                                                                                    (function () {
                                                                                      return _vm.handlePermission(
                                                                                        action.permissions,
                                                                                        scope.row
                                                                                      )
                                                                                    })(),
                                                                                  expression:
                                                                                    "\n                          (() =>\n                            handlePermission(action.permissions, scope.row))()\n                        ",
                                                                                },
                                                                              ],
                                                                            attrs:
                                                                              {
                                                                                command:
                                                                                  Object.assign(
                                                                                    {},
                                                                                    action,
                                                                                    scope.row
                                                                                  ),
                                                                              },
                                                                          },
                                                                          [
                                                                            action.name &&
                                                                            _vm.$baseLodash.isString(
                                                                              action.name
                                                                            )
                                                                              ? [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        action.name
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              : action.name &&
                                                                                _vm.$baseLodash.isFunction(
                                                                                  action.name
                                                                                )
                                                                              ? [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        action.name(
                                                                                          scope.row
                                                                                        )
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              : _vm._e(),
                                                                          ],
                                                                          2
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                : _vm.$baseLodash.has(
                                                                    action,
                                                                    "show"
                                                                  ) &&
                                                                  _vm.$baseLodash.isFunction(
                                                                    action.show
                                                                  )
                                                                ? [
                                                                    action.show(
                                                                      scope.row
                                                                    )
                                                                      ? _c(
                                                                          "el-dropdown-item",
                                                                          {
                                                                            directives:
                                                                              [
                                                                                {
                                                                                  name: "permissions",
                                                                                  rawName:
                                                                                    "v-permissions",
                                                                                  value:
                                                                                    (function () {
                                                                                      return _vm.handlePermission(
                                                                                        action.permissions,
                                                                                        scope.row
                                                                                      )
                                                                                    })(),
                                                                                  expression:
                                                                                    "\n                          (() =>\n                            handlePermission(action.permissions, scope.row))()\n                        ",
                                                                                },
                                                                              ],
                                                                            attrs:
                                                                              {
                                                                                command:
                                                                                  Object.assign(
                                                                                    {},
                                                                                    action,
                                                                                    scope.row
                                                                                  ),
                                                                              },
                                                                          },
                                                                          [
                                                                            action.name &&
                                                                            _vm.$baseLodash.isString(
                                                                              action.name
                                                                            )
                                                                              ? [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        action.name
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              : action.name &&
                                                                                _vm.$baseLodash.isFunction(
                                                                                  action.name
                                                                                )
                                                                              ? [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        action.name(
                                                                                          scope.row
                                                                                        )
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              : _vm._e(),
                                                                          ],
                                                                          2
                                                                        )
                                                                      : _c(
                                                                          "el-dropdown-item",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                width:
                                                                                  "85px",
                                                                              },
                                                                          }
                                                                        ),
                                                                  ]
                                                                : _c(
                                                                    "el-dropdown-item",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "permissions",
                                                                            rawName:
                                                                              "v-permissions",
                                                                            value:
                                                                              (function () {
                                                                                return _vm.handlePermission(
                                                                                  action.permissions,
                                                                                  scope.row
                                                                                )
                                                                              })(),
                                                                            expression:
                                                                              "\n                        (() =>\n                          handlePermission(action.permissions, scope.row))()\n                      ",
                                                                          },
                                                                        ],
                                                                      attrs: {
                                                                        command:
                                                                          Object.assign(
                                                                            {},
                                                                            action,
                                                                            scope.row
                                                                          ),
                                                                      },
                                                                    },
                                                                    [
                                                                      action.name &&
                                                                      _vm.$baseLodash.isString(
                                                                        action.name
                                                                      )
                                                                        ? [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  action.name
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        : action.name &&
                                                                          _vm.$baseLodash.isFunction(
                                                                            action.name
                                                                          )
                                                                        ? [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  action.name(
                                                                                    scope.row
                                                                                  )
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        : _vm._e(),
                                                                    ],
                                                                    2
                                                                  ),
                                                            ],
                                                            2
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ],
                                                  1
                                                ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                "el-table-column",
                                Object.assign(
                                  {},
                                  _vm.actionCenterColumn,
                                  _vm.actionsColumn,
                                  column
                                ),
                                false
                              )
                            )
                          : [
                              column.children
                                ? _c(
                                    "el-table-column",
                                    _vm._b(
                                      {
                                        key: index + "children",
                                        attrs: { sortable: null },
                                      },
                                      "el-table-column",
                                      Object.assign(
                                        {},
                                        _vm.defaultColumnConfig,
                                        column
                                      ),
                                      false
                                    ),
                                    _vm._l(
                                      column.children,
                                      function (
                                        childrenItem,
                                        childrenItemIndex
                                      ) {
                                        return _c(
                                          "el-table-column",
                                          _vm._b(
                                            {
                                              key: childrenItemIndex + "son",
                                              attrs: {
                                                "show-overflow-tooltip": "",
                                                sortable: null,
                                                formatter:
                                                  childrenItem.formatter
                                                    ? childrenItem.formatter
                                                    : _vm.formatter,
                                              },
                                            },
                                            "el-table-column",
                                            Object.assign(
                                              {},
                                              _vm.defaultColumnConfig,
                                              childrenItem
                                            ),
                                            false
                                          )
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : [
                                    !column.sortable
                                      ? _c(
                                          "el-table-column",
                                          _vm._b(
                                            {
                                              key: index + "norender",
                                              attrs: {
                                                index: index,
                                                formatter: column.formatter
                                                  ? column.formatter
                                                  : _vm.formatter,
                                                "show-overflow-tooltip": "",
                                              },
                                            },
                                            "el-table-column",
                                            Object.assign(
                                              {},
                                              _vm.defaultColumnConfig,
                                              column
                                            ),
                                            false
                                          )
                                        )
                                      : _vm.hasPager || _vm.enSortable
                                      ? _c(
                                          "el-table-column",
                                          _vm._b(
                                            {
                                              key: index + "norender",
                                              attrs: {
                                                index: index,
                                                formatter: column.formatter
                                                  ? column.formatter
                                                  : _vm.formatter,
                                                sortable: "custom",
                                                "show-overflow-tooltip": "",
                                              },
                                            },
                                            "el-table-column",
                                            Object.assign(
                                              {},
                                              _vm.defaultColumnConfig,
                                              column
                                            ),
                                            false
                                          )
                                        )
                                      : _c(
                                          "el-table-column",
                                          _vm._b(
                                            {
                                              key: index + "norender",
                                              attrs: {
                                                index: index,
                                                formatter: column.formatter
                                                  ? column.formatter
                                                  : _vm.formatter,
                                                sortable: "",
                                                "show-overflow-tooltip": "",
                                              },
                                            },
                                            "el-table-column",
                                            Object.assign(
                                              {},
                                              _vm.defaultColumnConfig,
                                              column
                                            ),
                                            false
                                          )
                                        ),
                                  ],
                            ],
                      ],
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "vab-contextmenu",
        { ref: "contextmenu" },
        _vm._l(_vm.list, function (item, index) {
          return _c(
            "vab-contextmenu-item",
            {
              key: index,
              attrs: { disabled: item.disabled },
              on: {
                click: function ($event) {
                  return _vm.handleContextMenu(item)
                },
              },
            },
            [
              _c("vab-icon", { attrs: { icon: item.icon } }),
              _vm._v(" " + _vm._s(item.title) + " "),
            ],
            1
          )
        }),
        1
      ),
      _vm.customConfig
        ? _c("product-item", {
            ref: "productItem",
            attrs: {
              check: _vm.checkList,
              list: _vm.columns,
              "custom-config": _vm.customConfig,
            },
            on: {
              "update:check": function ($event) {
                _vm.checkList = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }